module.exports = __webpack_public_path__ + "assets_1781767203318/img/guide_ios.431fc979.png";